// extracted by mini-css-extract-plugin
export default {"container":"FoodsDirectoryModal_container__fsChN","title":"FoodsDirectoryModal_title__SbgN-","loading":"FoodsDirectoryModal_loading__AlgfE","row":"FoodsDirectoryModal_row__rxHKg"};